<div class="page-wrapper pt-4">
  <div class="card rounded shadow-lg">
    <div class="dashboard-content">
      <!-- Updated page title and subtitle for CDE -->
      <h1 class="page-title">County Director Dashboard</h1>
      <p class="page-subtitle">
        {{ countyName }} - Educational Oversight & Management
      </p>

      <!-- Updated stats cards with CDE-specific KPIs -->
      <div class="row mb-4">
        <div class="col md-2">
          <div class="stat-card h-100 cursor-pointer" (click)="navigateToReview(2,0)">
            <i class="fas fa-school stat-icon"></i>
            <div class="stat-number">
              {{ dashboardDetails?.INSTITUTION_APPROVAL_STATUS?.total }}
            </div>
            <div class="stat-label">Approved Institutions</div>
            <div class="stat-sublabel">Registered under KEMIS</div>
          </div>
        </div>
         <div class="col md-2">
          <div class="stat-card h-100 cursor-pointer" (click)="navigateToReview(3,0)">
            <i class="fas fa-school stat-icon"></i>
            <div class="stat-number">
              {{ dashboardDetails?.INSTITUTION_APPROVAL_STATUS?.reject }}
            </div>
            <div class="stat-label">Rejected Institutions</div>
            <div class="stat-sublabel">Registered under KEMIS</div>
          </div>
        </div>
         <div class="col md-2">
          <div class="stat-card h-100 cursor-pointer" (click)="navigateToReview(1,0)">
            <i class="fas fa-clipboard-list stat-icon"></i>
            <div class="stat-number">
              {{ dashboardDetails?.PENDING_APPLICATIONS?.total }}
            </div>
            <div class="stat-label">Pending Applications</div>
            <div class="stat-sublabel">Awaiting CDE Review</div>
          </div>
        </div>
        <div class="col md-2">
          <div class="stat-card h-100 cursor-pointer" (click)="goToSchoolApproval()">
            <i class="fas fa-balance-scale stat-icon"></i>
            <div class="stat-number">
              {{ dashboardDetails?.TRANSFER_APPEALS?.total }}
            </div>
            <div class="stat-label">Transfer Appeals</div>
            <div class="stat-sublabel">Requiring Decision</div>
          </div>
        </div>
         <div class="col md-2">
          <div class="stat-card h-100 cursor-pointer" (click)="navigationTLUrl()">
            <i class="fas fa-users stat-icon"></i>
            <div class="stat-number">
              {{ dashboardDetails?.TOTAL_LEARNERS?.total }}
            </div>
            <div class="stat-label">Total Learners</div>
            <div class="stat-sublabel">County-wide Enrollment</div>
          </div>
        </div>
      </div>

      <!-- Charts Row -->
      <div class="row mb-4">
        <!-- Institution approval status breakdown -->
        <div class="col-md-6 mb-2">
          <div class="chart-card h-100">
            <div class="chart-header">
              <i class="fas fa-check-circle me-2"></i>
              <div>
                <div class="chart-title">
                  Institution Approval Status Breakdown
                </div>
                <div class="chart-subtitle">
                  Current status of institution applications
                </div>
              </div>
            </div>
            <div class="chart-body">
              <div class="progress-item">
                <div class="progress-label">
                  <span
                    style="
                      display: inline-block;
                      width: 12px;
                      height: 12px;
                      background-color: #00adee;
                      border-radius: 2px;
                      margin-right: 8px;
                    "
                  ></span>
                  Approved
                </div>
                <div class="progress-bar-container">
                  <div
                    class="progress-bar-fill success"
                    [style.width.%]="
                      (+dashboardDetails?.INSTITUTION_APPROVAL_STATUS?.total *
                        100) /
                      dashboardDetails?.TOTAL_INSITUTIONS?.total
                    "
                  ></div>
                </div>
                <div class="progress-value">
                  {{ dashboardDetails?.INSTITUTION_APPROVAL_STATUS?.total }}
                </div>
              </div>
              <div class="progress-item">
                <div class="progress-label">
                  <span
                    style="
                      display: inline-block;
                      width: 12px;
                      height: 12px;
                      background-color: #ffc107;
                      border-radius: 2px;
                      margin-right: 8px;
                    "
                  ></span>
                  Pending
                </div>
                <div class="progress-bar-container">
                  <div
                    class="progress-bar-fill warning"
                    style="background-color: #ffc107 !important"
                    [style.width.%]="
                      (+dashboardDetails?.INSTITUTION_APPROVAL_STATUS?.pending *
                        100) /
                      +dashboardDetails?.TOTAL_INSITUTIONS?.total
                    "
                  ></div>
                </div>
                <div class="progress-value">
                  {{ dashboardDetails?.INSTITUTION_APPROVAL_STATUS?.pending }}
                </div>
              </div>
              <div class="progress-item">
                <div class="progress-label">
                  <span
                    style="
                      display: inline-block;
                      width: 12px;
                      height: 12px;
                      background-color: #b91c1c;
                      border-radius: 2px;
                      margin-right: 8px;
                    "
                  ></span>
                  Rejected
                </div>
                <div class="progress-bar-container">
                  <div
                    class="progress-bar-fill danger"
                    [style.width.%]="
                      (+dashboardDetails?.INSTITUTION_APPROVAL_STATUS?.reject *
                        100) /
                      dashboardDetails?.TOTAL_INSITUTIONS?.total
                    "
                  ></div>
                </div>
                <div class="progress-value">
                  {{ dashboardDetails?.INSTITUTION_APPROVAL_STATUS?.reject }}
                </div>
              </div>

              <div class="summary-stats">
                <div class="summary-stat">
                  <div class="summary-number success">
                    {{ dashboardDetails?.INSTITUTION_APPROVAL_STATUS?.total }}
                  </div>
                  <div class="summary-label">Approved</div>
                </div>
                <div class="summary-stat">
                  <div
                    class="summary-number warning"
                    style="color: #ffc107 !important"
                  >
                    {{ dashboardDetails?.INSTITUTION_APPROVAL_STATUS?.pending }}
                  </div>
                  <div class="summary-label">Pending</div>
                </div>
                <div class="summary-stat">
                  <div class="summary-number danger">
                    {{ dashboardDetails?.INSTITUTION_APPROVAL_STATUS?.reject }}
                  </div>
                  <div class="summary-label">Rejected</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Institution categories pie chart -->
        <div class="col-md-6 mb-2">
          <div class="chart-card h-100">
            <div class="chart-header">
              <i class="fas fa-chart-pie me-2"></i>
              <div>
                <div class="chart-title">Institution Categories</div>
                <div class="chart-subtitle">
                  Distribution by institution type
                </div>
              </div>
            </div>
            <div class="chart-body">
              <div class="pie-chart-container">
                <div class="pie-chart">
                  <svg width="200" height="200" viewBox="0 0 200 200">
                    <!-- Background circle -->
                    <circle
                      cx="100"
                      cy="100"
                      r="80"
                      fill="none"
                      stroke="#e9ecef"
                      stroke-width="40"
                    />

                    <!-- Regular institutions -->
                    <circle
                      cx="100"
                      cy="100"
                      r="80"
                      fill="none"
                      stroke="#00adee"
                      stroke-width="40"
                      [attr.stroke-dasharray]="
                        getSegmentLength('total') + ' 502.4'
                      "
                      stroke-dashoffset="0"
                      transform="rotate(-90 100 100)"
                    />

                    <!-- Integrated institutions -->
                    <circle
                      cx="100"
                      cy="100"
                      r="80"
                      fill="none"
                      stroke="#ffc107"
                      stroke-width="40"
                      [attr.stroke-dasharray]="
                        getSegmentLength('reject') + ' 502.4'
                      "
                      [attr.stroke-dashoffset]="'-' + getSegmentLength('total')"
                      transform="rotate(-90 100 100)"
                    />

                    <!-- SNE institutions -->
                    <circle
                      cx="100"
                      cy="100"
                      r="80"
                      fill="none"
                      stroke="#28a745"
                      stroke-width="40"
                      [attr.stroke-dasharray]="
                        getSegmentLength('pending') + ' 502.4'
                      "
                      [attr.stroke-dashoffset]="
                        '-' +
                        (getSegmentLength('total') + getSegmentLength('reject'))
                      "
                      transform="rotate(-90 100 100)"
                    />
                  </svg>
                </div>
                <div class="pie-legend">
                  <div class="legend-item">
                    <span
                      class="legend-color"
                      style="background-color: #00adee"
                    ></span>
                    <span class="legend-label"
                      >Regular
                      {{
                        dashboardDetails?.INSTITUTION_CATEGORIES?.total
                      }}</span
                    >
                    <span class="legend-percent"
                      >{{
                        ((+dashboardDetails?.INSTITUTION_CATEGORIES?.total ||
                          0) /
                          ((+dashboardDetails?.INSTITUTION_CATEGORIES?.total ||
                            0) +
                            (+dashboardDetails?.INSTITUTION_CATEGORIES
                              ?.reject || 0) +
                            (+dashboardDetails?.INSTITUTION_CATEGORIES
                              ?.pending || 0) || 1)) *
                          100 | number : "1.0-1"
                      }}%</span
                    >
                  </div>
                  <div class="legend-item">
                    <span
                      class="legend-color"
                      style="background-color: #ffc107"
                    ></span>
                    <span class="legend-label"
                      >Integrated ({{
                        dashboardDetails?.INSTITUTION_CATEGORIES?.reject
                      }})</span
                    >
                    <span class="legend-percent"
                      >{{
                        ((+dashboardDetails?.INSTITUTION_CATEGORIES?.reject ||
                          0) *
                          100) /
                          ((+dashboardDetails?.INSTITUTION_CATEGORIES?.total ||
                            0) +
                            (+dashboardDetails?.INSTITUTION_CATEGORIES
                              ?.reject || 0) +
                            (+dashboardDetails?.INSTITUTION_CATEGORIES
                              ?.pending || 0) || 1) | number : "1.0-1"
                      }}%</span
                    >
                  </div>
                  <div class="legend-item">
                    <span
                      class="legend-color"
                      style="background-color: #28a745"
                    ></span>
                    <span class="legend-label"
                      >SNE ({{
                        dashboardDetails?.INSTITUTION_CATEGORIES?.pending
                      }})</span
                    >
                    <span class="legend-percent"
                      >{{
                        ((+dashboardDetails?.INSTITUTION_CATEGORIES?.pending ||
                          0) *
                          100) /
                          ((+dashboardDetails?.INSTITUTION_CATEGORIES?.total ||
                            0) +
                            (+dashboardDetails?.INSTITUTION_CATEGORIES
                              ?.reject || 0) +
                            (+dashboardDetails?.INSTITUTION_CATEGORIES
                              ?.pending || 0) || 1) | number : "1.0-1"
                      }}%</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Distribution by sub-county row -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="chart-card h-100">
            <div class="chart-header">
              <i class="fas fa-chart-bar me-2"></i>
              <div>
                <div class="chart-title">
                  Distribution of Institutions by Sub-County
                </div>
                <div class="chart-subtitle">
                  Institution count across all sub-counties in Nairobi
                </div>
              </div>
            </div>
            <div class="chart-body">
              <div class="row">
                <div class="col-lg-12 text-center">
                  <canvas
                    baseChart
                    [datasets]="barChartData"
                    [labels]="barChartLabels"
                    [options]="barChartOptions"
                    [chartType]="barChartType"
                    [legend]="false"
                  >
                  </canvas>
                </div>
              </div>
              <!-- <div class="chart-container">
                <div class="y-axis-label">
                  Number of Institutions
                </div>
                <div class="y-axis">
                  <span>200</span>
                  <span>150</span>
                  <span>100</span>
                  <span>50</span>
                  <span>0</span>
                </div>
                <div class="bar-chart-wide">
                  <div class="d-flex flex-column align-items-center">
                    <div class="bar-thin" style="height: 80%">
                      156
                    </div>
                    <div class="bar-label-small">Westlands</div>
                  </div>
                  <div class="d-flex flex-column align-items-center">
                    <div class="bar-thin" style="height: 65%">
                      134
                    </div>
                    <div class="bar-label-small">Starehe</div>
                  </div>
                  <div class="d-flex flex-column align-items-center">
                    <div class="bar-thin" style="height: 90%">
                      178
                    </div>
                    <div class="bar-label-small">Kasarani</div>
                  </div>
                  <div class="d-flex flex-column align-items-center">
                    <div class="bar-thin" style="height: 55%">
                      112
                    </div>
                    <div class="bar-label-small">Langata</div>
                  </div>
                  <div class="d-flex flex-column align-items-center">
                    <div class="bar-thin" style="height: 70%">
                      145
                    </div>
                    <div class="bar-label-small">Dagoretti</div>
                  </div>
                  <div class="d-flex flex-column align-items-center">
                    <div class="bar-thin" style="height: 60%">
                      122
                    </div>
                    <div class="bar-label-small">Kibra</div>
                  </div>
                  <div class="d-flex flex-column align-items-center">
                    <div class="bar-thin" style="height: 45%">
                      98
                    </div>
                    <div class="bar-label-small">Mathare</div>
                  </div>
                  <div class="d-flex flex-column align-items-center">
                    <div class="bar-thin" style="height: 75%">
                      152
                    </div>
                    <div class="bar-label-small">Embakasi</div>
                  </div>
                  <div class="d-flex flex-column align-items-center">
                    <div class="bar-thin" style="height: 50%">
                      105
                    </div>
                    <div class="bar-label-small">Makadara</div>
                  </div>
                  <div class="d-flex flex-column align-items-center">
                    <div class="bar-thin" style="height: 85%">
                      167
                    </div>
                    <div class="bar-label-small">Kamukunji</div>
                  </div>
                  <div class="d-flex flex-column align-items-center">
                    <div class="bar-thin" style="height: 40%">
                      89
                    </div>
                    <div class="bar-label-small">Ruaraka</div>
                  </div>
                </div>
                <div class="x-axis-label">Sub-Counties</div>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- Updated Quick Actions for CDE role -->
      <div class="row">
        <div class="col-12">
          <div class="quick-actions">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <div class="actions-title">Quick Actions</div>
                <div class="actions-subtitle">
                  Manage county educational operations efficiently
                </div>
              </div>
              <div class="action-buttons">
                <button class="action-btn" (click)="navigateToReview(0,0)">
                  <i class="fas fa-clipboard-check"></i>
                  Review Application
                </button>
                <button class="action-btn">
                  <i class="fas fa-chart-line"></i>
                  View County Reports
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
